import { Section } from "@/components/details";
import { Module } from "@/constants";
import { readEmailType } from "@/schemas/emailType";
import { ReadEmailType } from "@/types/emailType";

interface EmailTypeEditorSectionProps {
  emailType: ReadEmailType;
}

export const EmailTypeEditorSection = ({
  emailType,
}: EmailTypeEditorSectionProps) => (
  <Section
    className="mb-6"
    module={Module.EmailTypes}
    schema={readEmailType}
    data={emailType}
    variant="card"
  >
    <Section.Field field="name" />
    <Section.Field field="code" />
  </Section>
);
